import React from 'react'
import styles from './ErrorField.module.scss'

interface IProps {
  text: React.ReactNode
}

const ErrorField: React.FC<IProps> = ({ text }) => {
  return (
    <>
      {text !== '' ? (
        <p className={`text-danger ${styles.text} errorField`}>{text}</p>
      ) : (
        <div className={`${styles.offset} errorField`} />
      )}
    </>
  )
}

export default ErrorField
